// @flow
import React, { Component } from "react";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import Paper from "elevate-ui/Paper";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import compact from "lodash/compact";

type Props = {
  availableFilters: Object,
  classes: Object,
  cleanFilters: Function,
  filterValues: Object,
  filters: Array<Object>,
  handleSectionSelect: Function,
  mlsApiVersion: number,
};

class ReviewFilters extends Component<Props> {
  availableFilters = (section, transformedFilters) => {
    const { availableFilters } = this.props;
    return compact(
      /* eslint-disable */
      Object.keys(availableFilters[section]).map((key) => {
        /* eslint-enable */
        const filter = availableFilters[section][key]; // e.g. city
        // $FlowFixMe
        let matchingFilter = find(transformedFilters, (value, key) => {
          if (this.props.mlsApiVersion === 1) {
            return filter.key === key;
          }
          return (
            filter.name === key ||
            (filter.synonyms ? filter.synonyms.includes(key) : "")
          );
        });

        if (matchingFilter) {
          //Changes numeric value of cityId to the city name for ux review.
          if (
            filter.name === "aCityID" &&
            Array.isArray(matchingFilter) &&
            matchingFilter.length > 0
          ) {
            const selectedCities = filter.options
              .filter((cityObj) =>
                matchingFilter.includes(cityObj.value.toString())
              )
              .map((cityObj) => cityObj.label);
            matchingFilter = selectedCities;
          }
          return (
            <Typography type="body" key={key}>
              <strong>{filter.label}:</strong>{" "}
              {Array.isArray(matchingFilter)
                ? matchingFilter.join(", ")
                : matchingFilter}
            </Typography>
          );
        }
      })
    );
  };

  availableSections = (transformedFilters) => {
    const { availableFilters, classes, handleSectionSelect } = this.props;
    return Object.keys(availableFilters).map((section) => {
      if (isEmpty(availableFilters[section])) {
        return null;
      }

      return (
        <Paper withPadding={false} key={section} className={classes.section}>
          <div className={classes.sectionHeader}>
            <Typography type="body">
              <strong>{section}</strong>
            </Typography>
            <div>
              <button
                type="button"
                className={classes.editButton}
                onClick={() => handleSectionSelect(section)}
              >
                Edit
              </button>
            </div>
          </div>
          <Typography type="body2" className={classes.sectionBody}>
            {this.availableFilters(section, transformedFilters).length ? (
              this.availableFilters(section, transformedFilters)
            ) : (
              <Typography type="body">No Filters Applied</Typography>
            )}
          </Typography>
        </Paper>
      );
    });
  };

  render() {
    const { classes, cleanFilters, filterValues } = this.props;
    const transformedFilters = cleanFilters(filterValues);
    return (
      <div className={classes.root}>
        <Typography type="heading3">Review</Typography>
        <Typography type="body">
          Review/edit filters for property listings.
        </Typography>
        {this.availableSections(transformedFilters)}
      </div>
    );
  }
}

const styles = (theme) => ({
  "@global": {
    strong: {
      fontWeight: 600,
    },
  },
  root: {
    padding: 24,
  },
  section: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    margin: "22px 0",
  },
  sectionHeader: {
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.colors.gray["200"],
    padding: 16,
  },
  sectionBody: {
    padding: "24px 16px",
  },
  editButton: {
    fontSize: 14,
    textAlign: "right",
    textTransform: "uppercase",
    color: theme.colors.primary["500"],
    appearance: "none",
  },
});

export default withStyles(styles, { name: "ReviewFilters" })(ReviewFilters);
